<template>
    <div class="space-stats-page" v-wechat-title="`结对空间统计_双优云桥-智慧研修平台`">
        <div class="space-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">结对空间统计</span>
            </div>

            <div class="panel" v-loading="regionLoading">
                <template v-if="!regionEmpty">
                    <div class="panel-hd">
                        <h2>空间列表</h2>
                        <div class="toolbar">
                            <div class="filter-tabs">
                                <button
                                    v-for="tab in pairFilters"
                                    :key="tab.key"
                                    type="button"
                                    class="filter-tab"
                                    :class="{ 'is-active': activePair === tab.key }"
                                    @click="onPairFilterChange(tab.key)"
                                >{{ tab.name }}<span class="count">({{ tab.count }})</span></button>
                            </div>
                            <label class="search-box">
                                <i class="el-icon-search"></i>
                                <input
                                    v-model.trim="keyword"
                                    type="search"
                                    placeholder="搜索空间名称"
                                />
                            </label>
                            <button type="button" class="btn btn-ghost" @click="exportData">导出数据</button>
                        </div>
                    </div>

                    <div class="table-scroll" v-loading="listLoading">
                        <table class="data-table">
                            <thead>
                                <tr>
                                    <th>空间名称</th>
                                    <th>省区</th>
                                    <th>结对校单位</th>
                                    <th>班级空间</th>
                                    <th>成员</th>
                                    <th>课程</th>
                                    <th>作业</th>
                                    <th>观思问</th>
                                    <th>资源</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="row in displayRows" :key="row.spaceId || row.name">
                                    <td class="name-cell">{{ row.name }}</td>
                                    <td>
                                        <span
                                            v-if="row.regionLabel"
                                            class="prov-tag"
                                        >{{ row.regionLabel }}</span>
                                        <span v-else>--</span>
                                    </td>
                                    <td>{{ row.partners || '--' }}</td>
                                    <td>{{ row.classes }}</td>
                                    <td>{{ row.members }}</td>
                                    <td>{{ row.courses }}</td>
                                    <td>{{ row.works }}</td>
                                    <td>{{ row.gsw }}</td>
                                    <td>{{ row.resources }}</td>
                                </tr>
                                <tr v-if="!listLoading && displayRows.length === 0">
                                    <td colspan="9" class="empty-cell">
                                        <ph-empty
                                            size="table"
                                            :text="keyword || activePair !== 'all' ? '未找到匹配的空间' : '暂无空间数据'"
                                            :subtext="keyword ? '请尝试更换搜索关键词或筛选条件' : ''"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="pager-wrap" v-if="pages.total > 0 && !keyword">
                        <pagination
                            :total="pages.total"
                            :page.sync="pages.currentPage"
                            :limit.sync="pages.pageSize"
                            @pagination="handlePageChange"
                        />
                    </div>
                </template>
                <ph-empty
                    v-else-if="!regionLoading"
                    size="page"
                    text="暂无空间统计"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'
import { normalizeRegionLabel, mergeRegionFilterTabs } from './region-label.js'

export default {
    name: 'ProjectHomeSpaceStats',
    components: { pagination, PhEmpty },
    data() {
        return {
            keyword: '',
            activePair: 'all',
            regionLoading: false,
            regionEmpty: true,
            listLoading: false,
            pairFilters: [],
            tableData: [],
            pages: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    computed: {
        ...mapState({
            currentProject: state => state.user.currentProject
        }),
        projectId() {
            return this.$route.params.id
        },
        canFetchStats() {
            return [4, 5, 6, 9].includes(Number(this.currentProject && this.currentProject.modelType))
        },
        activePairProvinceIds() {
            const tab = this.pairFilters.find(item => item.key === this.activePair)
            return (tab && tab.provinceIds) || []
        },
        displayRows() {
            if (!this.keyword) return this.tableData
            const key = this.keyword.toLowerCase()
            return this.tableData.filter(row =>
                (row.name || '').toLowerCase().includes(key)
            )
        }
    },
    watch: {
        keyword() {
            // 仅前端过滤当前页，不重置服务端分页
        },
        'currentProject.modelType'() {
            this.fetchRegionStats()
        },
        '$route.params.id'() {
            this.fetchRegionStats()
        }
    },
    methods: {
        toStatNumber(val) {
            const n = Number(val)
            return Number.isFinite(n) ? n : 0
        },
        mapSchoolSpaceRow(item) {
            return {
                spaceId: item.spaceId,
                name: item.spaceName || '',
                regionLabel: normalizeRegionLabel(item.regionLabel || '') || (item.regionLabel || ''),
                provinceIds: item.provinceIds || [],
                partners: item.schoolNames || '',
                classes: this.toStatNumber(item.classSpaceCount),
                members: this.toStatNumber(item.memberCount),
                courses: this.toStatNumber(item.courseCount),
                works: this.toStatNumber(item.homeworkCount),
                gsw: this.toStatNumber(item.gswCount),
                resources: this.toStatNumber(item.resourceCount)
            }
        },
        resetRegionEmpty() {
            this.regionEmpty = true
            this.pairFilters = []
            this.activePair = 'all'
            this.tableData = []
            this.pages.total = 0
            this.pages.currentPage = 1
            this.keyword = ''
        },
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        exportData() {
            this.$message.info('导出数据功能暂未接入接口')
        },
        onPairFilterChange(key) {
            if (this.activePair === key) return
            this.activePair = key
            this.pages.currentPage = 1
            this.keyword = ''
            this.fetchSchoolSpaces()
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.keyword = ''
            this.fetchSchoolSpaces()
        },
        async fetchRegionStats() {
            if (!this.projectId || !this.canFetchStats) {
                this.resetRegionEmpty()
                return
            }
            this.regionLoading = true
            try {
                const res = await this.$Api.Paired.getProjectSpaceRegionStats({
                    projectId: this.projectId
                })
                const data = (res && res.data) || {}
                const list = Array.isArray(data.list) ? data.list : []
                const total = this.toStatNumber(data.total)
                if (total <= 0 && list.length === 0) {
                    this.resetRegionEmpty()
                    return
                }
                this.pairFilters = [
                    {
                        key: 'all',
                        name: '全部',
                        count: total,
                        provinceIds: []
                    },
                    ...mergeRegionFilterTabs(list, this.toStatNumber)
                ]
                this.regionEmpty = false
                if (!this.pairFilters.some(item => item.key === this.activePair)) {
                    this.activePair = 'all'
                }
                this.pages.currentPage = 1
                await this.fetchSchoolSpaces()
            } catch (e) {
                this.resetRegionEmpty()
            } finally {
                this.regionLoading = false
            }
        },
        async fetchSchoolSpaces() {
            if (!this.projectId || !this.canFetchStats || this.regionEmpty) {
                this.tableData = []
                this.pages.total = 0
                return
            }
            this.listLoading = true
            const activeTab = this.pairFilters.find(item => item.key === this.activePair)
            const regionLabel = activeTab && activeTab.key !== 'all' ? activeTab.name : ''
            try {
                if (regionLabel) {
                    const allTotal = this.toStatNumber(
                        (this.pairFilters.find(item => item.key === 'all') || {}).count
                    )
                    const provinceIds = (this.activePairProvinceIds || [])
                        .map(id => Number(id))
                        .filter(id => Number.isFinite(id))
                    if (provinceIds.length) {
                        const res = await this.$Api.Paired.getProjectSchoolSpaces({
                            projectId: this.projectId,
                            page: this.pages.currentPage,
                            limit: this.pages.pageSize,
                            provinceIds
                        })
                        const records = ((res && res.data && res.data.records) || [])
                        const total = this.toStatNumber(res && res.data && res.data.total)
                        if (records.length || total > 0) {
                            this.tableData = records.map(item => this.mapSchoolSpaceRow(item))
                            this.pages.total = total
                            return
                        }
                    }
                    const fb = await this.$Api.Paired.getProjectSchoolSpaces({
                        projectId: this.projectId,
                        page: 1,
                        limit: Math.max(allTotal, this.pages.pageSize, 50)
                    })
                    const matched = ((fb && fb.data && fb.data.records) || [])
                        .filter(item => {
                            const label = normalizeRegionLabel(item.regionLabel || '') || (item.regionLabel || '')
                            return label === regionLabel
                        })
                    const start = (this.pages.currentPage - 1) * this.pages.pageSize
                    this.tableData = matched
                        .slice(start, start + this.pages.pageSize)
                        .map(item => this.mapSchoolSpaceRow(item))
                    this.pages.total = matched.length
                    return
                }

                const res = await this.$Api.Paired.getProjectSchoolSpaces({
                    projectId: this.projectId,
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize
                })
                const data = (res && res.data) || {}
                this.tableData = (data.records || []).map(item => this.mapSchoolSpaceRow(item))
                this.pages.total = this.toStatNumber(data.total)
            } catch (e) {
                this.tableData = []
                this.pages.total = 0
            } finally {
                this.listLoading = false
            }
        }
    },
    mounted() {
        this.fetchRegionStats()
    }
}
</script>

<style lang="less" scoped>
.space-stats-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.space-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    border: 1px solid transparent;
    line-height: 1;
}

.btn-ghost {
    background: #fff;
    border-color: #dcdfe6;
    color: #666;

    &:hover {
        color: #01A2FD;
        border-color: #01A2FD;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
    min-height: 240px;
}

.panel-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 0 20px;
    line-height: 56px;
    border-bottom: 1px solid rgba(199, 199, 199, 0.4);
    background: rgba(250, 251, 255, 1);
    flex-wrap: wrap;

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        white-space: nowrap;
    }
}

.toolbar {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    min-width: 0;
}

.filter-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
}

.filter-tab {
    padding: 0 12px;
    height: 56px;
    border: none;
    background: transparent;
    color: #666;
    font-size: 13px;
    cursor: pointer;
    position: relative;
    font-family: inherit;
    white-space: nowrap;

    .count {
        margin-left: 2px;
        opacity: 0.75;
    }

    &:hover,
    &.is-active {
        color: #01A2FD;
    }

    &.is-active::after {
        content: "";
        position: absolute;
        left: 10px;
        right: 10px;
        bottom: 0;
        height: 2px;
        background: #01A2FD;
        border-radius: 1px;
    }
}

.search-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 34px;
    padding: 0 12px;
    border: 1px solid #e0e6ed;
    border-radius: 4px;
    background: #fff;
    box-sizing: border-box;

    i {
        color: #999;
        font-size: 14px;
    }

    input {
        border: none;
        outline: none;
        width: 160px;
        font-size: 13px;
        color: #333;
        background: transparent;
        font-family: inherit;

        &::placeholder {
            color: #bbb;
        }
    }
}

.table-scroll {
    overflow-x: auto;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;

    th {
        text-align: left;
        padding: 14px;
        background: #fafbff;
        color: #666;
        font-weight: 400;
        white-space: nowrap;
    }

    td {
        padding: 14px;
        color: #555;
        border-bottom: 1px solid #f5f7fa;
        vertical-align: middle;
    }

    tbody tr:hover td:not(.empty-cell) {
        background: #EAF6FF;
    }

    .name-cell {
        color: #333;
        font-weight: 500;
        min-width: 200px;
    }

    .empty-cell {
        padding: 0;
        border-bottom: none;
        background: transparent !important;
    }
}

.prov-tag {
    display: inline-block;
    padding: 2px 8px;
    margin: 2px 4px 2px 0;
    font-size: 12px;
    font-weight: 500;
    color: #01A2FD;
    background: #EAF6FF;
    border-radius: 3px;
}

.pager-wrap {
    padding: 8px 16px 16px;
}

@media screen and (min-width: 1250px) {
    .space-wrap {
        width: 1200px;
    }
}
</style>
